const CUSTOM_FONT_CLASSES = {
	merriweather: 'font-merriweather',
	comic_sans: 'font-comic-sans',
	roboto: 'font-roboto',
	roboto1: 'font-roboto-1',
	roboto2: 'font-roboto-2',
	roboto3: 'font-roboto-3',
	roboto4: 'font-roboto-4',
	roboto5: 'font-roboto-5',
	roboto6: 'font-roboto-6'
};

const removeFontTrackingScript = () => {
	const script = document.body.querySelector('script.font-tracking-script');

	if (script) {
		const trackingStyleSheet = document.querySelector(`link[href*="${window.MTUserId}"]`);

		if (trackingStyleSheet) {
			trackingStyleSheet.remove();
		}

		window.MTUserId = undefined;
		window.MTFontIds = undefined;

		script.remove();
	}
};

const addFontTrackingScript = () => {
	const existingScript = document.body.querySelector('script.font-tracking-script');

	if (existingScript) {
		return;
	}

	window.MTUserId = 'b6b43671-009c-4ad6-8062-61f9da21ca91';
	window.MTFontIds = ['1061472']; // Comic Sans® W01 Regular

	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.async = 'true';
	if (!window.readworks.config.rwtesting) {
		script.src = '/assets/dist/fonts/comic-sans/mtiFontTrackingCode.js';
	}
	script.classList.add('font-tracking-script');

	document.body.appendChild(script);

	window.addEventListener('beforeunload', removeFontTrackingScript);
};

const getCustomFontClass = fontKey => {
	if (fontKey in CUSTOM_FONT_CLASSES) {
		const customFontClass = CUSTOM_FONT_CLASSES[fontKey];

		if (customFontClass === CUSTOM_FONT_CLASSES.comic_sans) {
			addFontTrackingScript();
		}

		return customFontClass;
	}

	return undefined;
};

const FONT_SIZE_CLASSES = ['', '-font-m', '-font-l', '-font-xl'];

const FONT_SIZE_STATES = ['n', 'm', 'l', 'xl'];

const getNextFontSizeClass = currentClass => {
	let index = FONT_SIZE_CLASSES.indexOf(currentClass);
	index = (index + 1) % FONT_SIZE_CLASSES.length;
	const fontSizeClass = FONT_SIZE_CLASSES[index];
	const state = FONT_SIZE_STATES[index];

	return {
		fontSizeClass,
		state
	};
};

module.exports = {
	CUSTOM_FONT_CLASSES,
	getCustomFontClass,
	FONT_SIZE_CLASSES,
	FONT_SIZE_STATES,
	getNextFontSizeClass
};
